export const environment = {
  production: false,
  env: 'development',
  jasperEnv: 'dev',
  apiURL: 'https://devbackend.schoolvoices360.com',
  jasperServerUrl: 'https://jasper2.schoolvoices360.com:8447/jasperserver-pro/client/visualize.js?_opt=true',
  jasperServerUsername: 'joeuser',
  jasperServerPassword: 'ForFeedback@123'
};

